/// <amd-module name="TFS/Admin/Groups/Pivots/Users/Redux/UsersPivotReducers" />
import produce from "immer";
import * as Resources from "TFS/Admin/Groups/Common/Resources";
import { UsersPivotActions, UsersPivotActionTypes } from "TFS/Admin/Groups/Pivots/Users/Redux/UsersPivotActions";
import { IUsersPivotState } from "TFS/Admin/Groups/Common/Contracts";
import { MessageCardSeverity } from "VSSUI/MessageCard";
import { SearchStatus } from "TFS/Admin/Groups/Common/Constants";

export function usersPivotReducer(state: IUsersPivotState, action: UsersPivotActions): IUsersPivotState {
    return produce(state || {}, draft => {
        switch (action.type) {
            case UsersPivotActionTypes.InitView: {
                draft.data = {
                    totalIdentityCount: 0,
                    identities: [],
                    moreData: true
                };
                draft.searchResult = {
                    keyword: "",
                    resultItems: [],
                    status: SearchStatus.None,
                    hasMore: false
                };
                draft.messageCardText = undefined;
                break;
            }

            case UsersPivotActionTypes.InitialUsersLoadSucceeded: {
                var { users, continuationToken } = action.payload;

                draft.data = {
                    totalIdentityCount: users.length,
                    identities: users,
                    moreData: continuationToken && continuationToken.length > 0 ? true : false,
                    continuationToken: action.payload.continuationToken
                };
                draft.initComplete = true;
                draft.loading = false;
                break;
            }

            case UsersPivotActionTypes.UsersLoadFailed: {
                draft.messageCardText = Resources.UsersLoadFailed;
                draft.messageCardSeverity = MessageCardSeverity.Error;
                draft.data.moreData = false;
                draft.initComplete = false;
                draft.loading = false;
                break;
            }

            case UsersPivotActionTypes.FetchMoreUsersSucceeded: {
                var { users, continuationToken } = action.payload;

                draft.data = {
                    totalIdentityCount: draft.data.totalIdentityCount + users.length,
                    identities: draft.data.identities.slice(0, draft.data.identities.length).concat(users),
                    moreData: continuationToken && continuationToken.length > 0 ? true : false,
                    continuationToken: continuationToken
                };
                draft.loading = false;
                draft.initComplete = false;
                break;
            }

            case UsersPivotActionTypes.UserOperationStatus: {
                var { resultMessage, severity } = action.payload;
                draft.messageCardText = resultMessage;
                draft.messageCardSeverity = severity;
                break;
            }

            case UsersPivotActionTypes.DismissMessageCard: {
                draft.messageCardText = undefined;
                break;
            }

            case UsersPivotActionTypes.SearchUsers: {
                updateSearchStatus(draft, SearchStatus.Searching);
                break;
            }

            case UsersPivotActionTypes.UpdateSearchStatus: {
                updateSearchStatus(draft, action.payload);
                break;
            }

            case UsersPivotActionTypes.UpdateSearchResult: {
                updateSearchResult(draft, action.payload.keyword, action.payload.result, action.payload.hasMore);
                break;
            }

            default:
                return state;
        }
    });
}

function updateSearchStatus(state: IUsersPivotState, searchStatus: SearchStatus) {
    const { searchResult } = state;
    if (!searchResult) {
        return;
    }
    if (searchStatus === SearchStatus.None) {
        searchResult.resultItems = [];
        searchResult.keyword = "";
    }
    searchResult.status = searchStatus;
}

function updateSearchResult(state: IUsersPivotState, keyword: string, results: any[], hasMore: boolean) {
    if (!keyword || !state.searchResult) {
        return;
    }
    state.searchResult = {
        keyword,
        resultItems: results,
        status: SearchStatus.Completed,
        hasMore
    };
}
